import React, {useState, useLayoutEffect} from 'react'
import styled from "@emotion/styled/macro"
import SvgMenuIcon from '../images/SVGs/MenuIcon'
import { theme } from './Theme'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import SvgPhoneIcon from "../images/SVGs/PhoneIcon"
import SvgMobileMenuRedShape from "../images/SVGs/MobileMenuRedShape"
import SvgRightArrow from "../images/SVGs/RightArrow"
import { MobileAndSidebarMenuItems } from "./MobileAndSidebarMenuItems"
import { CustomModal } from './CustomModal'
import { Form } from './Form'

const PopupButton = (props) =>{
  const [isModalOpen, setIsModalOpen] = useState(false)
  return(
      <>
       <button 
       className='calloutButton'
       onClick={() => setIsModalOpen(true)}
       >
                  <p>
                    {props.buttonText}
                  </p>
                  <SvgRightArrow />
                </button>
<CustomModal onClose={() => setIsModalOpen(false)} isModalOpen={isModalOpen} modalContent={<Form data={props.formData} />} />
</>
  )
}

function useLockBodyScroll(){
  useLayoutEffect(() => {
    // Get Y offset
    const windowOffset = window.scrollY
    
    //Make body stay at that Y offset and disable body scrolling
    document.body.setAttribute('style', `position: fixed; top: -${windowOffset}px; left: 0; right: 0; overflow: hidden;`)

    
    // Re-enable scrolling when component unmounts
    return () => {
      document.body.setAttribute('style', '')
      window.scrollTo(0, windowOffset)
     
    };
  }, []); // Empty array ensures effect is only run on mount and unmount


}



function Sidebar(props){
  
  const MobileMenuContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 2;
  overflow-y: auto;
  overflow-x: hidden;

  .innerContainer{
    flex-grow: 1;
      width: 85%;
  padding: 0 1.125rem;
  box-sizing: border-box;
  background-color: ${theme.colors.light};
  z-index: 1;
  transition: 850ms;
  position: relative;
  
  }
  @keyframes inAnimation {
      0%{
        right: -100%;
  
          
      }
  100% {
    right: 0;
    
  }
}
  .active{
      animation-name: inAnimation;
animation-duration: 0.5s;
animation-timing-function: ease-in;
animation-direction: normal;
animation-iteration-count: 1;
animation-play-state: running;

  }
  .closeButton{
      appearance: none;
      border: none;
      background-color: transparent;
      font-size: 2.0625rem;
  }

.centerImage{
  display: flex;
  justify-content: center;
}
.closeMenu{
  position: absolute;
width: 100vw;
height: 100vh;
}
.logoContainer{
  display: block;
  text-align: center;

  .gatsby-image-wrapper{
    max-width: 50%;
  }
}
.mobileMenuBottom{
  position: relative;
  display: grid;
  width: 85%;
  transition: 850ms;
  z-index: 1;
  background-color: ${theme.colors.light};
}

.redShape{
  grid-area: 1/1;
  width: 100%;
}
.phoneButtonContainer{
  grid-area: 1/1;
  position: absolute;
  top: 75%;
  left: 50%;
  transform: translate(-50%, -75%);
  width: 100%;
  padding: 0 1.125rem;
  box-sizing: border-box;
}
.phoneIconContainer{
display: flex;
gap: 0.5rem;
font-weight: 800;
font-size: 1.9375rem;
justify-content: center;
align-items: center;;
color: ${theme.colors.light};
margin-bottom: 1rem;
transition: transform 0.2s ease-in;
svg{
      transition: transform 0.2s ease-in;
    }
    &:hover, &:active{
      color: ${theme.colors.secondary};
        svg{
          transform: rotate(25deg); 
          circle{
             
                  fill: ${theme.colors.secondary};
              
          }
        }
    }
}
.calloutButton{
color: ${theme.colors.light};
background-color: ${theme.colors.dark};
padding: 1.25rem 1.9375rem;
display: flex;
justify-content: center;
align-items: center;
gap: 1.1875rem;
appearance: none;
border: none;
width: 100%;
font-family: ${theme.fonts.altFont};
font-size: 1.0625rem;
font-weight: 700;
text-transform: uppercase;
letter-spacing: 1px;
transform: perspective(1px) translateZ(0);
position: relative;
transition-property: color;
transition-duration: 0.3s;
&:before{
  content: "";
position: absolute;
z-index: -1;
top: 0;
left: 0;
right: 0;
bottom: 0;
background: ${theme.colors.secondary};
transform: scaleX(0);
transform-origin: 0 50%;
transition-property: transform;
transition-duration: 0.3s;
transition-timing-function: ease-out;
}
&:hover:before, &:active:before{
transform: scaleX(1);
}
  &:hover, &:active{
    cursor: pointer;
    color: ${theme.colors.dark};
    & path {
  fill: ${theme.colors.dark};
}
  }
}
ul{
  list-style: none;
}

  `
  const GatsbyImageStyled = styled(GatsbyImage)`
  
  transition: none;
  pointer-events: none;

    `
   
      useLockBodyScroll();
   
    
    
    
  return(
<>

        <MobileMenuContainer
        
        >
            <div className='closeMenu' 
onClick={() => props.setSidebarOpen(false)} />
            <div className={props.isActive === true ?`innerContainer active` :  `innerContainer`}>
            <button 
            className="closeButton"
            onClick={() => props.setSidebarOpen(false)}
            >
            x
            </button>
            <Link className='logoContainer' to="/">
            <GatsbyImageStyled image={props.headerData.logo} alt='logo'/>
            </Link>
            <MobileAndSidebarMenuItems mainMenuItems={props.mainMenuItems} isSidebar={false} />
            </div>
            <div className={props.isActive === true ? `mobileMenuBottom active` : `mobileMenuBottom`}>
              <SvgMobileMenuRedShape className="redShape" preserveAspectRatio="none" />
              <div className="phoneButtonContainer">
                  <a className="phoneIconContainer" href={`tel:`+props.headerData.phoneNumber}>
                  <SvgPhoneIcon />
                  <p>
                    {props.headerData.phoneNumber}
                  </p>
                  </a>
               <PopupButton headerData={props.headerData} formData={props.formData} buttonText={props.buttonText} />
              </div>
            </div>
        </MobileMenuContainer>
        
</>
  )
}
const NavMobile = (props) =>{
    const MenuButton = styled.button`
     display: flex;
        gap: 1rem;
        align-items: center;
        font-weight: 700;
        font-size: 1.25rem;
        text-transform: uppercase;
        appearance: none;
        border: none;
        background-color: transparent;

        &:hover, &:active{
            cursor: pointer;
        }

        p{
          display: none;
        }
        @media (min-width: 490px){
          p{
            display: inline;
          }
        }
    `
   
      const [sidebarOpen, setSidebarOpen] = useState(false)
      const [isActive, setIsActive] = useState(false)
    

  function menuOpen(){
      setSidebarOpen(true);
      setIsActive(true);
      
  }
    
    
    return(
        <>
        <MenuButton
        onClick={menuOpen}
        >
    <SvgMenuIcon  />
    <p>
        Menu
    </p>
</MenuButton>
{sidebarOpen === true &&
       <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} isActive={isActive} mainMenuItems={props.mainMenuItems} headerData={props.headerData} formData={props.formData} buttonText={props.buttonText} />
}
        </>
    )
}
export {NavMobile}